// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section id="customer-deposit-accounts-cash-action" class="box product-operation">
  <sub-header header="'Interest cash withdrawal'"></sub-header>

    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Product name:</span>
        <span class="value">{{\$ctrl.termDeposit.productName}}</span>
      </div>
      <div class="info-detail">
        <span class="key">Available balance:</span>
        <span class="value"
              ng-class="{'currency--positive': \$ctrl.termDeposit.balance > 0, 'currency--negative': \$ctrl.termDeposit.balance < 0}">
          {{\$ctrl.termDeposit.balance | nxCurrency}}
        </span>
      </div>
      <div class="override">
        <span class="key">Override withdraw amount:</span>
        <span class="value">
          <input type="checkbox"
                 ng-model="\$ctrl.overrideCheckbox"
                 ng-disabled="\$ctrl.termDeposit.depositSubgroup === 'ADVANCE_INTEREST'"/>
        </span>
      </div>
    </div>

    <h2 class="section-header">Please confirm the following:</h2>
    <form name="\$ctrl.transactionForm">
      <table class="misc-transaction__table table table--generate-row-ids">
        <thead>
        <tr ng-if="\$ctrl.overrideCheckbox">
          <td></td>
          <td></td>
          <td ng-if="\$ctrl.overrideCheckbox">
            Default
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            Override
          </td>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td></td>
          <td>Gross interest:</td>
          <td>
            <cash ng-disabled="true"
              ng-model="\$ctrl.interestForecast.interest"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="\$ctrl.override.interest"
              ng-change="\$ctrl.updateOverrides()"
              ng-required="true"></cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Withholding tax:</td>
          <td>
            <cash ng-model="\$ctrl.interestForecast.withholdingTax"
              ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox && \$ctrl.taxRecalculated">
            <cash ng-model="\$ctrl.override.withholdingTax"
              ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox && !\$ctrl.taxRecalculated">
            <button class="btn btn-info" id="recalculate-tax-btn" ng-click="\$ctrl.recalculateTax()">Recalculate tax</button>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Withdrawal amount:</td>
          <td>
            <cash ng-disabled="true" ignore-amount-validation="\$ctrl.overrideCheckbox" ng-model="\$ctrl.withdrawalAmount"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox && \$ctrl.taxRecalculated">
            <cash ng-disabled="true" ng-model="\$ctrl.override.amount"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox && !\$ctrl.taxRecalculated">
            <cash ng-disabled="true"></cash>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="buttons">
        <signature-card
          file-id="\$ctrl.termDeposit.signatureCardFileId"
          product-group="'DEPOSIT'"
          product-status="\$ctrl.termDeposit.status"></signature-card>
        <button class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
        <button class="btn btn-danger" ng-click="\$ctrl.withdraw()"
                ng-disabled="\$ctrl.transactionForm.invalid || !\$ctrl.withdrawalEnabled() || (\$ctrl.overrideCheckbox && !\$ctrl.taxRecalculated)">
          Withdraw
        </button>
      </div>
    </form>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/interests-cash-withdrawal/interests-cash-withdrawal.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;